import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCallingV2Service, API_CONFIG } from '@zayan-erp/shared';
import {
  CommissionReportFilterRequest,
  ConsultantCommissionReportData,
  DecorCancellationReportData
} from '../models/dsm-commission-report.models';

@Injectable({
  providedIn: 'root'
})
export class DsmCommissionReportService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getConsultantCommissionReport(req: CommissionReportFilterRequest): Observable<ConsultantCommissionReportData> {
    return this.#http.postData<ConsultantCommissionReportData>(
      `${this.baseUrl}/dsm-reports/consultant-commission`,
      { showLoader: false, showMessage: false },
      req
    );
  }

  getDecorCancellationReport(req: CommissionReportFilterRequest): Observable<DecorCancellationReportData> {
    return this.#http.postData<DecorCancellationReportData>(
      `${this.baseUrl}/dsm-reports/decor-cancellation`,
      { showLoader: false, showMessage: false },
      req
    );
  }

  downloadCommissionPdf(req: CommissionReportFilterRequest): Observable<void> {
    const filename = `consultant_commission_${+new Date()}.pdf`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/dsm-reports/consultant-commission/pdf`,
      req,
      { showLoader: true, buttonId: 'consultant-commission-pdf', showMessage: true },
      filename
    );
  }

  downloadCommissionExcel(req: CommissionReportFilterRequest): Observable<void> {
    const filename = `consultant_commission_${+new Date()}.xlsx`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/dsm-reports/consultant-commission/excel`,
      req,
      { showLoader: true, buttonId: 'consultant-commission-excel', showMessage: true },
      filename
    );
  }

  downloadCancellationPdf(req: CommissionReportFilterRequest): Observable<void> {
    const filename = `decor_cancellation_${+new Date()}.pdf`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/dsm-reports/decor-cancellation/pdf`,
      req,
      { showLoader: true, buttonId: 'consultant-commission-pdf', showMessage: true },
      filename
    );
  }

  downloadCancellationExcel(req: CommissionReportFilterRequest): Observable<void> {
    const filename = `decor_cancellation_${+new Date()}.xlsx`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/dsm-reports/decor-cancellation/excel`,
      req,
      { showLoader: true, buttonId: 'consultant-commission-excel', showMessage: true },
      filename
    );
  }
}
